import * as React from "react";

function SvgCallingly(props, ref) {
  return (
    <svg
      id="Callingly_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 20 250 238"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style />
      <path
        d="M178.63 58.53c-1.28-3.1-3.22-5.72-5.26-7.56-2.2-1.74-4.15-3.14-6.03-4.33a50.38 50.38 0 00-4.23-2.4c-12.84-6.81-27.46-10.68-43.01-10.68-44.77 0-82.06 31.96-90.35 74.3a92.638 92.638 0 00-2.02 19.2c0 10.55 1.8 20.68 5.07 30.11 3.42 9.88 5.28 14.67 11.65 22.7 1 1.11 2.23 2.15 3.6 3.03 1.54.99 3.27 1.77 5.08 2.24.71.18 1.43.34 2.17.42 4.44 1.13 9.57.81 14.7-2.3 10.13-6.14 16.83-24.5 15.78-32.01-1.02-7.6-4.7-12.11-9.49-12.65-4.42-.5-8.89 3.2-12.82-6.03-9.67-22.73 34.65-69.26 63.08-63.08 8.5 1.85 5.53 8.39 6.03 12.82.54 4.79 5.05 8.47 12.65 9.49 7.51 1.05 25.87-5.65 32.01-15.78 3.8-6.24 3.46-12.49 1.39-17.49z"
        fill="#24a9df"
      />
      <path
        d="M192.79 73.81c-.81 3.19-2.06 6.31-3.87 9.29-3.79 6.25-9.99 11.25-16.73 14.96a58.311 58.311 0 017.21 28.15c0 32.37-26.33 58.7-58.7 58.7a58.31 58.31 0 01-28.26-7.27c-3.88 7.12-9.13 13.53-15.35 17.3-3.21 1.95-6.57 3.3-10.05 4.09 10.59 7.8 22.9 13.37 36.29 15.93 5.46 1.04 11.09 1.49 16.85 1.58 23.9.41 14.95 34.23 14.95 34.23 52.43-32.02 74.92-84.8 74.92-124.1 0-19.76-6.42-38.02-17.26-52.86z"
        fill="#053b4c"
      />
    </svg>
  );
}

export default React.forwardRef(SvgCallingly);
